import { useTranslation } from 'react-i18next'
import type { AttendanceStatus } from '@/api/attendance'
import { cn } from '@/lib/utils'

interface LearnerAttendanceStatusBadgeProps {
  status: AttendanceStatus | null
}

export function LearnerAttendanceStatusBadge({ status }: LearnerAttendanceStatusBadgeProps) {
  const { t } = useTranslation('learner')
  const isProcessed = status === 'IN' || status === 'OUT'
  const label = t(
    isProcessed
      ? 'profile.profile.attendanceStatus.processed'
      : 'profile.profile.attendanceStatus.before',
  )

  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-3 py-1.5',
        'text-lc-v3-caption-1 font-semibold',
        isProcessed
          ? 'bg-lc-success-50 text-lc-success-700'
          : 'bg-lc-v3-gray-100 text-lc-text-secondary',
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'size-2 shrink-0 rounded-full',
          isProcessed ? 'bg-lc-success-500' : 'bg-lc-v3-gray-500',
        )}
      />
      {label}
    </span>
  )
}
